module.exports = __webpack_public_path__ + "static/media/geo-use-cases.89d6c24c.svg";